import React from "react";

import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import useResponsiveFlags from "../../hooks/useResponsiveFlags";

export default function TokenHeadFiles(props) {
  const { order, orderBy, onSort } = props;
  const { isSmallMobileScreen } = useResponsiveFlags();
  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={
            !isSmallMobileScreen
              ? {
                  position: "sticky",
                  top: 0,
                  left: 0,
                  zIndex: 12,
                }
              : {}
          }
        >
        </TableCell>
        <TableCell
          style={{
            minWidth: "200px",
            ...(!isSmallMobileScreen
              ? {
                  position: "sticky",
                  top: 0,
                  left: 45,
                  zIndex: 11,
                }
              : {}),
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Token
            </span>
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "150px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Org
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "orgname"}
              onClick={() => onSort("orgname")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "126.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Type
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "type"}
              onClick={() => onSort("type")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "134px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Total Samples
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "total_samples"}
              onClick={() => onSort("total_samples")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Remain Samples
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "remain_samples"}
              onClick={() => onSort("remain_samples")}
            />
          </div>
        </TableCell>

        <TableCell style={{ minWidth: "97px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Pending Samples
            </span>
            <SortingIcon
              order={order}
              active={orderBy === "pending_samples"}
              onClick={() => onSort("pending_samples")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Expire
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "expire"}
              onClick={() => onSort("expire")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Last Used
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "last_used"}
              onClick={() => onSort("last_used")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Created
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "created"}
              onClick={() => onSort("created")}
            />
          </div>
        </TableCell>
        <TableCell style={{ minWidth: "109.5px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>
              Locked
            </span>

            <SortingIcon
              order={order}
              active={orderBy === "locked"}
              onClick={() => onSort("locked")}
            />
          </div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

function SortingIcon({ order, active, onClick }) {
  return (
    <span
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "inline-flex",
        flexDirection: "column",
        //   alignItems: "center",
        //   marginLeft: "5px",
      }}
    >
      <span
        style={{
          color: active && order === "asc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▲
      </span>
      <span
        style={{
          color: active && order === "desc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▼
      </span>
    </span>
  );
}
